import store from 'src/js/store';
import hideHoveredHighlighter from '../actions/hide-hovered';

function hideHovered(elements) {
  store.dispatch(hideHoveredHighlighter(elements));
}

export default hideHovered;
